import styled from 'styled-components';

const BrowseSubtitle = styled.div`
  font-weight: 900;
  letter-spacing: 1px;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
`;

export default BrowseSubtitle;
